import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { connect } from 'react-redux'
import {
  Box,
  Tab,
  Tabs,
} from '@material-ui/core'

import { LIST_TYPE, ROUTES } from '../constant'
import { getUsers, getExpiredWallets } from '../actions/user'
import { getAmountInfos } from '../helpers'
import Loading from '../components/Loading'
import TabPanel from '../components/TabPanel'
import Section from '../components/Section'
import Breadcrumb from '../components/Breadcrumb'
import TableAutomation from '../components/TableAutomation'
import { InputTelSearch } from '../components/InputTelSearch'
import QueryBuilder from '../lib/queryBuilder'


const styles = {
  filter: {
    paddingX: "20px",
  },
  gap: {
    gap: "10px",
  },
}


class ListUsers extends Component {
  /* LIFECYCLE */

  constructor(props) {
    super(props)

    this.state = {
      phone: '',
      tabIndex: 0,
      direction: 'desc',
      orderBy: 'created_at',
    }
  }

  /* METHODS */

  handlePhoneChange = phone => this.setState({ phone })

  handleChange = e => this.setState({ [e.target.name]: e.target.value })

  handleTabChange = (e, nextValue) => this.setState({ tabIndex: nextValue })

  handleItemClick = (item) => {
    this.props.history.push(`${ROUTES.USER}/${item.id}`)
  }

  handlegetExpiredWallets = () => {
    const {
      orderBy,
      direction,
    } = this.state

    this.props.getExpiredWallets({
      orderBy,
      direction,
    })
  }

  renderUserRow = (user) => {
    const { totalAmount, currentAmount, lastExpirationDate } = getAmountInfos(user)

    return [
      user.phone,
      user.email,
      user.client_name,
      `${totalAmount} €`,
      user.created_at ? moment(user.created_at).format('DD/MM/YYYY - HH:mm') : 'N/A',
      lastExpirationDate ? moment(lastExpirationDate).format('DD/MM/YYYY') : 'N/A',
      `${currentAmount} €`,
    ]
  }

  renderWalletRow = (wallet) => {
    return [
      wallet.client_name,
      `${wallet.initial_amount} €`,
      moment(wallet.created_at).format('DD/MM/YYYY'),
      moment(wallet.amount_expired_at).format('DD/MM/YYYY'),
      `${wallet.amount_expired} €`,
    ]
  }

  handleSortClick = (orderBy) => () => {
    const reverseDirection = this.state.direction === 'asc' ? 'desc' : 'asc'

    this.setState({
      orderBy,
      direction: this.state.orderBy === orderBy ? reverseDirection : 'desc',
    }, this.handlegetExpiredWallets)
  }

  getUsers = (options = {}) => {
    this.props.getUsers({
      ...options,
      where: this.state.where,
    })
  }

  onSubmitPhone = (phone) => {
    const where = phone ? new QueryBuilder().where('phone', '==', phone) : undefined
    this.setState({ where })

    this.props.getUsers({ where })
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      items,
      hasMore,
      isLoading,
      endBefore,
      startAfter,
      hasPrevious,
    } = this.props

    const {
      // orderBy,
      tabIndex,
      // direction,
    } = this.state

    return (
      <div>
        <Breadcrumb
          data={[
            { label: 'Accueil', to: '/' },
            'Utilisateurs',
          ]}
        />

        {isLoading && <Loading />}

        <Section disableArrow title="Liste des utilisateurs">
          <Tabs centered value={tabIndex} onChange={this.handleTabChange}>
            <Tab label="Tous" />
            <Tab label="Wallet Expirés" />
          </Tabs>

          <Box sx={styles.filter}>
            <InputTelSearch onSubmit={this.onSubmitPhone} />
          </Box>

          <TabPanel hidden={tabIndex !== 0}>
            <TableAutomation
              disableMargin
              items={items}
              hasMore={hasMore}
              endBefore={endBefore}
              startAfter={startAfter}
              request={this.getUsers}
              row={this.renderUserRow}
              hasPrevious={hasPrevious}
              title="Liste des utilisateurs"
              onClick={this.handleItemClick}
              head={['Utilisateur', 'Email', 'Entreprise', 'Crédit', 'Date d\'ajout', 'Date expiration', 'Solde']}
            />
          </TabPanel>

          <TabPanel hidden={tabIndex !== 1}>
            <TableAutomation
              disableMargin
              items={items}
              hasMore={hasMore}
              endBefore={endBefore}
              startAfter={startAfter}
              row={this.renderWalletRow}
              hasPrevious={hasPrevious}
              title="Liste des wallets expirés"
              onClick={this.handleItemClick}
              request={this.handlegetExpiredWallets}
              head={[
                'Entreprise',
                'Montant initial',
                'Date d\'ajout',
                'Date d\'expiration',
                'Montant expiré',
              ]}
            />
          </TabPanel>
        </Section>
      </div>
    )
  }
}


ListUsers.propTypes = {
  hasMore: PropTypes.bool,
  hasPrevious: PropTypes.bool,
  endBefore: PropTypes.string,
  startAfter: PropTypes.string,
  getUsers: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  getExpiredWallets: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
}


const mapStateToProps = state => ({
  isLoading: state.app.isLoading,
  endBefore: state.list.endBefore,
  startAfter: state.list.startAfter,
  items: state.list.type === LIST_TYPE.USERS ? state.list.items : [],
  hasMore: state.list.type === LIST_TYPE.USERS ? state.list.hasMore : false,
  hasPrevious: state.list.type === LIST_TYPE.USERS ? state.list.hasPrevious : false,
})


export default connect(mapStateToProps, {
  getUsers,
  getExpiredWallets,
})(ListUsers)
